import { BaseApiService } from '@shared/services/base-api.service';
import { API_URL } from '../config/constants';
import { STORAGE_KEYS } from '@shared/constants';
import { authService } from './auth.service';
import { message } from 'antd';

let isHandlingUnauthorized = false;
const LOCK_DURATION = 10000;

class WebApiService extends BaseApiService {
  protected getBaseURL(): string {
    return API_URL;
  }

  protected async getAuthToken(): Promise<string | null> {
    return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
  }

  protected async handleUnauthorized(backendMessage?: string): Promise<void> {
    if (isHandlingUnauthorized) {
      return;
    }

    isHandlingUnauthorized = true;

    try {
      const displayMessage = backendMessage && backendMessage !== 'Unauthorized'
        ? backendMessage
        : 'Phiên đăng nhập hết hạn, vui lòng đăng nhập lại';

      message.warning(displayMessage);
      await authService.clearStorage();

      setTimeout(() => {
        window.location.href = '/login';
      }, 1000);
    } catch (error) {
      isHandlingUnauthorized = false;
      throw error;
    }

    setTimeout(() => {
      isHandlingUnauthorized = false;
    }, LOCK_DURATION);
  }
}

export const apiService = new WebApiService();

